import React, { useEffect, useState } from "react";
import aboutUAICLayout from "../../assets/img/aboutus/aboutUAICLayout.svg";
import checkIcon from "../../assets/img/aboutus/check.svg";
import { Container, Row, Col, Image, Card, Badge } from "react-bootstrap";
import "./ThinksRemember.css";
import claims from "../../assets/vids/claims.mp4";
import emptyCaptions from "../../components/empty-captions.vtt";

const ThinksRemember = ({ responsiveStatus }) => {
  const [backgroundVideo, setBackgroundVideo] = useState(claims);

  return (
    <>
      {/* <div style={styles.container}> */}
      <div style={{ margin: "0 auto", maxWidth: "1350px" }}>
        <Row
          style={{
            position: "relative",
            margin: "0 auto",
            maxWidth: "1350px",
          }}
        >
          {/* Left Column: Text Content */}
          <Col lg={6} className="position-relative mt-5 mt-lg-0 text-left">
            {responsiveStatus !== "isMobile" &&
              responsiveStatus !== "isSmallMobile" && (
                <div
                  className={`uaic-image-wrapper1 position-relative mx-auto ${
                    responsiveStatus === "isDesktop"
                      ? "uaic-image-wrapper1"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "uaic-image-wrapper1"
                      : "uaic-image-wrapper-mobile"
                  }`}
                >
                  <Image
                    src={require("../../assets/img/claims/left.svg")}
                    className="circle-background"
                    alt="Circular Background"
                    fluid
                  />

                  <div
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "video-overlay"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "video-overlay"
                        : "video-overlay-m"
                    }`}
                  >
                    <video
                      src={backgroundVideo}
                      autoPlay
                      muted
                      loop
                      playsInline
                      style={{
                        objectFit: "cover",
                        zIndex: 1,
                        width: "100%",
                        height: "100%",
                        transform: "scaleY(1.8)",
                        transformOrigin: "center center",
                        overflow: "hidden",
                        borderRadius: "50%",
                      }}
                    >
                      <track
                        kind="captions"
                        src={emptyCaptions}
                        srcLang="en"
                        label="English"
                      />
                    </video>
                  </div>
                </div>
              )}
          </Col>

          {/* Right Column: Image + Floating Cards */}
          <Col
            lg={6}
            style={{
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                color: "#17252E",
                fontSize: "15px",
                lineHeight: "140%",
                fontWeight: 600,
                whiteSpace: "nowrap",
                position: "relative", // required for ::after
                display: "inline-block",
              }}
            >
              <span
                style={{
                  position: "relative",
                  paddingBottom: "5px",
                }}
              >
                Things to Remember
                <span
                  style={{
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: -4,
                    height: "1.6px",
                    width: "70%", // Extend beyond text
                    backgroundColor: "#0e72d6",
                    transform: "translateX(0%)", // Centered extension
                  }}
                />
              </span>
            </p>

            <h1
              className="mt-2"
              style={{
                color: "#000",
                lineHeight: "100%",
                fontWeight:
                  responsiveStatus === "isDesktop"
                    ? 500
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? 500
                    : 600,

                fontSize:
                  responsiveStatus === "isDesktop"
                    ? "32px"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "32px"
                    : "18px",
              }}
            >
              What information do I need to know to report a claim?
            </h1>

            <ul
              className="gap-1"
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                marginTop: "1em",
              }}
            >
              {[
                "U.A.I.C policy number, For example, UAU 000000000",
                "Name, Insurance information and phone number of anyone else in the accident with you",
                "Police report number and department name",
                "The date, time and place of the accident",
                "Knowledge of what happened in the loss",
                "Location of your vehicle",
              ].map((item, i) => (
                <li
                  key={i}
                  style={{
                    marginBottom: "4px",
                    display: "flex",
                    alignItems: "left",
                  }}
                >
                  <img
                    src={checkIcon}
                    alt="check"
                    style={{
                      width: "20px",
                      marginRight: "10px",
                      verticalAlign: "top",
                    }}
                  />
                  <span className="claimTextStyle">{item}</span>
                </li>
              ))}
            </ul>

            {(responsiveStatus === "isMobile" ||
              responsiveStatus === "isSmallMobile") && (
              <div
                className={`uaic-image-wrapper1 position-relative mx-auto ${
                  responsiveStatus === "isDesktop"
                    ? "uaic-image-wrapper1"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "uaic-image-wrapper1"
                    : "uaic-image-wrapper-mobile"
                }`}
              >
                <Image
                  src={require("../../assets/img/claims/left.svg")}
                  className="circle-background"
                  alt="Circular Background"
                  fluid
                />

                <div
                  className={`${
                    responsiveStatus === "isDesktop"
                      ? "video-overlay"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "video-overlay"
                      : "video-overlay-m"
                  }`}
                >
                  <video
                    src={backgroundVideo}
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                      objectFit: "cover",
                      zIndex: 1,
                      width: "100%",
                      height: "100%",
                      transform: "scaleY(1.8)",
                      transformOrigin: "center center",
                      overflow: "hidden",
                      borderRadius: "50%",
                    }}
                  >
                    <track
                      kind="captions"
                      src={emptyCaptions}
                      srcLang="en"
                      label="English"
                    />
                  </video>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${aboutUAICLayout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default ThinksRemember;
